import { MenuItemType } from 'components/drawer/RenderMenu';
import { SortMenuType } from 'components/utils/Sort';
import { PROJECT_BULK_UPDATE } from 'constants/routes';
import useCompanyQuery from 'hooks/useCompanyQueries';
import useUserData from 'hooks/useUserData';
import { useMemo, useState } from 'react';
import { ReactComponent as Procore } from 'assets/icons/procore.svg';
import EditLineIcon from 'remixicon-react/EditLineIcon';
import { useNavigate } from 'react-router-dom';

function useProjectsMenu() {
  const navigate = useNavigate();
  const { companyId, isNovaOrCompanyAdmin } = useUserData();
  const { company } = useCompanyQuery({ companyId });
  const SORT_BY_LIST = [
    { label: 'Alphabetical (A-Z)', value: 1 },
    { label: 'Alphabetical (Z-A)', value: -1 },
  ];
  const [sortMenu, setSortMenu] = useState<SortMenuType>({
    selectedOption: SORT_BY_LIST[0],
    options: SORT_BY_LIST,
  });
  const [openImportProcoreProjectsModal, setOpenImportProcoreProjectsModal] = useState(false);
  const hasAccessToImportProcoreProjects = useMemo(
    () =>
      !!(
        company?.settings?.integrations?.procoreFlag &&
        company?.settings?.integrations?.projectsFlag
      ) && isNovaOrCompanyAdmin,
    [company?.settings?.integrations?.procoreFlag, company?.settings?.integrations?.projectsFlag],
  );
  const addProjectMenu = useMemo(
    () => [
      {
        title: 'Import from Procore',
        icon: <Procore width={18} height={18} />,
        isHidden: !hasAccessToImportProcoreProjects,
        onClick: () => setOpenImportProcoreProjectsModal(true),
      },
    ],
    [hasAccessToImportProcoreProjects],
  );
  const moreActionsMenu: MenuItemType[] = useMemo(
    () => [
      {
        title: 'Bulk Edit',
        icon: <EditLineIcon size={17} />,
        onClick: () => navigate(PROJECT_BULK_UPDATE),
      },
    ],
    [],
  );

  return {
    addProjectMenu,
    moreActionsMenu,
    openImportProcoreProjectsModal,
    sortMenu,
    setOpenImportProcoreProjectsModal,
    setSortMenu,
  };
}

export default useProjectsMenu;
